import { useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import { useReactToPrint } from "react-to-print";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint } from "@fortawesome/free-solid-svg-icons";
import Logo from "../logo.svg";
import { useSettings } from "../context/SettingsContext";
function ModalForm({
  show,
  onClose,
  title,
  children,
  onSubmit,
  loading,
  mode = "form", // form | confirm | print
  confirmText = "تأكيد",
  cancelText = "إلغاء",
  className,
}) {
  const printRef = useRef();
  const { settings } = useSettings();

  // إعداد الطباعة
  const handlePrint = useReactToPrint({
    contentRef: printRef,
    documentTitle: title,
    pageStyle: `
  @page {
    size: A4;
    margin: 10mm !important;
  }
  body {
    direction: rtl;
    font-family: 'Cairo', sans-serif;
    color: #000;
    background: #fff;
    position: relative;
    min-height: 100vh;
  }

  .print-header {
    text-align: center;
    border-bottom: 2px solid #000;
    padding-bottom: 10px;
    margin-bottom: 20px;
  }
  .print-header .title {
    font-size: 22px;
    margin: auto;
  }

  .print-content {
    padding-bottom: 60px; /* مساحة علشان الفوتر ما يغطيش المحتوى */
  }

  .print-footer {
    text-align: center;
    border-top: 2px solid #000;
    padding-top: 10px;
    font-size: 14px;
    color: #555;

    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
  }

  @media print {
    .print-footer {
      position: fixed;
      bottom: 0;
    }
  }
`,
  });

  return (
    <Modal show={show} onHide={onClose} centered className={className}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body
        ref={printRef}
        style={
          mode === "confirm"
            ? {
                textAlign: "center",
                fontWeight: "600",
                fontSize: "18px",
                padding: "20px",
              }
            : {}
        }>
        {mode === "print" && (
          <div className="print-header ">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h2 className="title">{title}</h2>
              {/* <img src={Logo} alt="Logo" width={80} /> */}
              {settings?.head_company_logo == 1 && (
                <img
                  src={settings?.company_logo}
                  alt="شعار الشركة"
                  style={{
                    width: "80px",
                    height: "auto",
                    borderRadius: "8px",
                  }}
                />
              )}
            </div>
            <div className="print-header-section  ">
              {settings?.head_company_name == 1 && (
                <div>
                  {" "}
                  <strong>اسم الشركة </strong>: {settings?.company_name || "--"}
                </div>
              )}
              {settings?.head_invoice_address == 1 && (
                <div className="">
                  <strong>العنوان </strong>: {settings?.company_address || "--"}
                </div>
              )}
            </div>

            <div className="print-header-section center"></div>

            <div className="print-header-section">
              <div>
                {" "}
                <strong>الهاتف</strong> : {settings?.company_phone || "--"}
              </div>
              <p className="mt-2">
                <strong>تاريخ الطباعة</strong>:{" "}
                {new Date().toLocaleString("ar-EG")}
              </p>
            </div>
          </div>
        )}

        <div className="print-content">{children}</div>

        {/* الفوتر الخاص بالطباعة */}
        {mode === "print" && (
          <div className="print-footer py-4">
            <div className="print-footer-section right">
              {settings?.foot_tax_number == 1 && (
                <div>
                  <strong>الرقم الضريبي</strong>:{" "}
                  {settings?.company_tax_number || "--"}
                </div>
              )}
              {settings?.foot_company_commercial == 1 && (
                <div className="fw-medium">
                  <strong>السجل التجاري</strong>:
                  {settings?.company_commercial || "--"}{" "}
                </div>
              )}
            </div>

            <div className="print-footer-section center">
              {settings?.foot_company_seal == 1 && (
                <div className="print-footer-section center">
                  <img
                    src={settings?.company_seal}
                    alt="ختم الشركة"
                    style={{
                      width: "80px",
                      height: "auto",
                      borderRadius: "8px",
                    }}
                  />{" "}
                </div>
              )}
            </div>

            <div className="print-footer-section left">
              {settings?.foot_company_website == 1 && (
                <div>
                  <strong>الموقع الإلكتروني</strong>:
                  {settings?.company_website || "https://www.facebook.com/"}{" "}
                </div>
              )}
              {settings?.footer_note && (
                <div
                  className="position-absolute text-center w-100"
                  style={{
                    top: "-30px",
                    right: "0",
                    transform: "translateY(-50%)",
                  }}>
                  <strong>ملاحظات الفاتورة:</strong> {settings.footer_note}
                </div>
              )}

              {settings?.foot_company_email == 1 && (
                <div>
                  <strong>البريد الإلكتروني</strong>:{" "}
                  {settings?.company_email || "exampel@info.com"}{" "}
                </div>
              )}
            </div>
            <div className="text-center mt-2" style={{ height: "0px" }}>
              بوابات الأعمال الدولية © {new Date().getFullYear()} -{" "}
              <span>www.ibgates.com</span>
            </div>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer dir="rtl">
        <Button variant="secondary" onClick={onClose}>
          {cancelText}
        </Button>

        {mode === "print" ? (
          <button className="btn btn-info" onClick={handlePrint}>
            <FontAwesomeIcon icon={faPrint} />
          </button>
        ) : mode !== "view" ? (
          <Button
            variant={mode === "confirm" ? "danger" : "primary"}
            onClick={onSubmit}
            disabled={loading}>
            {loading
              ? "جارٍ التنفيذ..."
              : mode === "confirm"
              ? confirmText
              : confirmText}
          </Button>
        ) : null}
      </Modal.Footer>
    </Modal>
  );
}

export default ModalForm;
